<template>
  <div class="chapter-color">
    <div class=" py-10" id="kapitel2">
      <v-container>
        <v-row class="justify-center">
          <v-col cols="12" class="text-center">
            <div
              class="text-uppercase display-2 pa-6 hidden-sm-and-down"
              style="color: #2E3440;"
            >
              Digitalisierung der Organisationen
            </div>
            <div
              class="text-uppercase headline pa-6 hidden-md-and-up"
              style="color: #2E3440;"
            >
              Digitalisierung der Organisationen
            </div>
            <v-divider
              style="border-color: #d62b03; border-width: 5px; width:50%; display: inline-block; border-style: dotted none none none"
            ></v-divider>
          </v-col>
        </v-row>
      </v-container>
    </div>
    <div class="component-color">
      <verantwortlichkeit></verantwortlichkeit>

      <infrastructureoverview></infrastructureoverview>
      <infrastructurestats></infrastructurestats>
      <verteilungBudget></verteilungBudget>
      <investitionen></investitionen>

      <q7107884></q7107884>
      <q7107899></q7107899>
    </div>
  </div>
</template>

<script>
import Verantwortlichkeit from "@/components/topics/statusquo/Verantwortlichkeit.vue";

import Infrastructureoverview from "@/components/topics/statusquo/Infrastructureoverview.vue";
import Infrastructurestats from "@/components/topics/statusquo/Infrastructurestats.vue";
import VerteilungBudget from "@/components/topics/statusquo/VerteilungBudget.vue";
import Investitionen from "@/components/topics/statusquo/Investitionen.vue";
import Q7107884 from "@/components/topics/statusquo/Q7107884.vue";
import Q7107899 from "@/components/topics/statusquo/Q7107899.vue";

export default {
  name: "Statusquo",
  components: {
    Verantwortlichkeit,
    Infrastructureoverview,
    Infrastructurestats,
    VerteilungBudget,
    Investitionen,
    Q7107884,
    Q7107899
  }
};
</script>

<style scoped>
.chapter-color {
  background-color: #f5f5f5;
  min-height: 20em;
}
</style>
